import React, { useState } from "react";
import queryString from "query-string";
import { Form, Progress, Alert } from "reactstrap";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from "./img/logo.png";
import photouser from "./img/photouser.png";
import photopassword from "./img/photopassword.png";

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [error, setError] = useState({ open: false, message: "" });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'wow';

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({ open: false, message: "" })


    api.userPassLogin({ username, password },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);
        let message = translate("RequestLoginErrorMessage")
        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message })
      });
  }

  return (
    <>
      <Form onSubmit={(event) => onSubmit(event)} className="wow-login">
        <div>
          <img src={logo} alt="wow" />
        </div>
        <div className="wow-wrapper">
          <div className="wow-form-group">
            <div className="wow-form-content">
              <div className="wow-form-container wow-form-container-login">
                <h1>{translate("LoginTitle")}</h1>

              </div>

              <div className="wow-form-container wow-input-container" >
                <img src={photouser} alt="wow" className="photoUser" />


                <div className="input-user">
                  <input
                    disabled={onLogin}
                    placeholder={translate("PlaceholderUserName")}
                    required={true}
                    tabIndex={1}
                    type="text"
                    autoCorrect="off"
                    autoCapitalize="none"
                    name="login"
                    id="login"
                    onChange={e => setUsername(e.target.value)}
                  />
                </div>
              </div>

              <div className="wow-form-container wow-input-container">


                <img src={photopassword} alt="wow" className="photoPassword" />


                <div className="input-password">
                  <input
                    required={true}
                    disabled={onLogin}
                    placeholder={translate("PlaceholderPassword")}
                    tabIndex={1}
                    type="password"
                    autoCorrect="off"
                    autoCapitalize="none"
                    id="password"
                    name="login"
                    onChange={e => setPassword(e.target.value)}
                  >
                  </input>
                </div>

              </div>
              <div className="wow-button">
                {!onLogin ? (
                  <button type="submit" disabled={!props.turnstileSuccess}>
                    <span className="wow-enter-text">
                      {translate("ButtonEnter")}
                    </span>
                  </button>
                ) : (
                  <Progress animated color="danger" value={100} />
                )}
              </div>
              <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
              <div className="messages-container">
                <Alert
                  color="danger"
                  id="error-message"
                  isOpen={error.open}
                  toggle={() => setError({ open: false })}
                >
                  {error.message}
                </Alert>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </>
  );
}
export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
